<template>
  <div class="home content-continer">
    <!-- 最上面项目详情 -->
    <div class="base-content items">
      <div style="margin-bottom:30px;">
        <a class="list-name">{{projectlists.projectName}}</a>
      </div>
      <ul class="list-msg">
        <li>
          <p>CRC人数</p>
          <p>{{projectlists.crcNum?projectlists.crcNum:'0'}}</p>
        </li>
        <li>
          <p>专业名称</p>
          <p>{{projectlists.specialityName?projectlists.specialityName:'无'}}</p>
        </li>
        <li>
          <p>负责人</p>
          <p>{{projectlists.managerName?projectlists.managerName:'无'}}</p>
        </li>
        <li>
          <p>项目类型</p>
          <p>{{projectlists.phaseDesc?projectlists.phaseDesc:'无'}}</p>
        </li>
        <li>
          <p>项目开始时间</p>
          <p>{{projectlists.startDate?projectlists.startDate:'无'}}</p>
        </li>
        <li>
          <p>申办方</p>
          <p>{{projectlists.sponsorName?projectlists.sponsorName:'无'}}</p>
        </li>
        <li>
          <p>医院名称</p>
          <p>{{projectlists.hospitalName?projectlists.hospitalName:'无'}}</p>
        </li>
        <!-- <li>
            <p>公司区域</p>
            <p>{{projectlists.smoProvince?projectlists.smoProvince:'无'}}</p>
        </li>-->
      </ul>
      <p class="remarks">{{projectlists.projectDesc?projectlists.projectDesc:'无'}}</p>
    </div>
    <!-- 人员列表 -->
    <div class="continer-title base-content">
      <div class="blue">委派日志</div>
    </div>
    <!-- 委派函 -->
    <div class="base-content reception">
      <ul>
        <li v-for="(item,index) in projectlists.list2" :key="index">
          <div class="wph">
            <p class="left">
              <span class="title_index">{{index+1}}</span>
              <span class="time">{{item.delTime}}</span>
            </p>
            <p class="right wphbtn" @click="wpcheck(item.delTime,projectlists.projectId)">委派函</p>
            <p style="clear:both"></p>
          </div>

          <div>
            <el-row :gutter="40">
              <el-col :span="4" v-for="(items,index) in item.list" :key="index">
                <div class="reception-msg">
                  <p v-if="items.delegateState==1">
                    <img src="../assets/hospital-img/no-w.png" class="status" />
                  </p>
                  <p v-if="items.delegateState==2">
                    <img src="../assets/hospital-img/s-no-j.png" class="status" />
                  </p>
                  <p v-if="items.delegateState==3">
                    <img src="../assets/hospital-img/s-y-j.png" class="status" />
                  </p>
                  <p v-if="items.delegateState==4">
                    <img src="../assets/hospital-img/b-return.png" class="return" />
                  </p>
                  <img :src="imgurl+items.headImg" />
                  <p>{{items.name}}</p>
                </div>
              </el-col>
            </el-row>
          </div>
        </li>
      </ul>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="900px">
      <el-button type="primary" icon="el-icon-printer"  v-print="'#printMe'">打印</el-button>
      <div id="printMe" >
        <div class="center crcheader">CRC委派函</div>  
        <div class="crccontent">
          致：{{wprzlist.hospitalName}}：
          <br />
          <p>&nbsp;&nbsp;&nbsp;&nbsp;我单位（{{wprzlist.companyName}}）现委派以下CRC人员前往贵单位进行“{{wprzlist.projectName}}”协助研究。服务期限自 {{wprzlist.startTime}} 起，至该试验在贵单位完成归档结束止。</p>
          <div class="mdan">
            <p class="headercrc">crc名单</p>
            <el-table :data="wprzlist.list" border style="width: 740px;">
              <el-table-column prop="crcName" label="姓名" width="180"></el-table-column>
              <el-table-column prop="sex" label="性别" width="180">
                <template slot-scope="scope">
                  <p v-if="scope.row.sex=='1'">男</p>
                  <p v-if="scope.row.sex=='2'">女</p>
                </template>
              </el-table-column>
              <el-table-column prop="idCardNum" label="身份证号" width="379"></el-table-column>
            </el-table>
          </div>
          <div style="margin-top:100px;padding-bottom:100px;">
            <p class="right center">
              {{wprzlist.companyName}}
              <br />
              {{wprzlist.createTime}}
            </p>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { receivingDetails2 } from "@/request/api";
import { appointLetter } from "@/request/api";

export default {
  name: "home",
  data() {
    return {
      projectid: "",
      userId: "",
      projectlists: "",
      imgurl: this.Common.imgurl,
      dialogVisible: false,
      wprzlist: ""
    };
  },
  methods: {
    wpcheck(time, id) {
      console.log(time, id);

      let data = {
        projectId: id,
        delegateDate: time
      };
      appointLetter(data)
        .then(res => {
          if ((res.data.code = "00000")) {
            this.dialogVisible = true;
            this.wprzlist = res.data.data;
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    receivingDetails2(this.projectid)
      .then(res => {
        this.projectlists = res.data.data;
        console.log(this.projectlists);
      })
      .catch(err => {
        console.log(err);
      });
  },
  created() {
    this.projectid = this.$route.params.projectId;
    this.userId = Cookies.get("userid");
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.items {
  margin-top: 20px;
  margin-bottom: 20px;
}

.items .list-name {
  font-size: 18px;
  color: #4d4d4d;
}

.items li {
  display: inline-block;
  margin-right: 30px;
  font-size: 14px;
}

.item li:last-child {
  margin-right: 0px;
}

.list-msg li p:first-child {
  color: #999999;
  /* font-weight:bold; */
}

.list-msg li p:last-child {
  color: #666666;
  margin-top: 10px;
  /* font-weight:bold; */
}

.remarks {
  width: 100%;
  /* height: 40px; */
  line-height: 40px;
  background: rgba(245, 245, 245, 1);
  color: #999999;
  font-size: 14px;
  margin-top: 26px;
  padding-left: 5px;
}

/* 委派函 */
.reception li > p:first-child {
  border-bottom: solid 1px #ccc;
  padding-bottom: 12px;
}

.reception li {
  /* margin-top: 60px; */
  margin-bottom: 20px;
}

.reception-title-icon {
  display: inline-block;
  width: 30px;
  height: 30px;
  text-align: center;
  border-radius: 50%;
  background: #3672bf;
  border: solid 4px #cae1ff;
  color: #fff;
  margin-right: 20px;
}

.reception-msg {
  text-align: center;
  /* margin-top: 40px; */
  position: relative;
  width: 120px;
}

.reception-msg img {
  width: 120px;
  height: 120px;
}

.status {
  position: absolute;
  right: 0;
  top: 0px;
  width: 60px !important;
  height: auto !important;
}

.return {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.title_index {
  display: inline-block;
  width: 34px;
  height: 34px;
  background: rgba(54, 114, 191, 1);
  border: 4px solid rgba(202, 225, 255, 1);
  border-radius: 50%;
  color: #fff;
  text-align: center;
  line-height: 26px;
  margin-right: 15px;
}
.wph {
  padding-bottom: 12px;
  border-bottom: solid 1px #cccccc;
  margin-bottom: 40px;
}
.time {
  font-size: 17px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(77, 77, 77, 1);
}
.wphbtn {
  height: 17px;
  font-size: 17px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(54, 114, 191, 1);
  cursor: pointer;
}
>>> .el-dialog__headerbtn .el-dialog__close,
.el-dialog__headerbtn .el-dialog__close:hover {
  color: #4d4d4d;
}
>>> .el-dialog__header {
  background: #fff;
}
.crcheader {
  font-size: 24px;
  font-family: SimSun;
  font-weight: bold;
}
.crccontent {
  font-size: 15px;
  line-height: 25px;
  padding: 0px 60px;
  margin-top: 30px;
}
.crccontent p {
  font-size: 15px;
}
.mdan {
  margin-top: 30px;
}
.mdan .headercrc {
  margin-bottom: 16px;
}
>>> .el-table th > .cell {
  font-weight: 400;
}
/* #printMe >>>table td{
  border:1px solid #EBEEF5!important;
} */
</style>


// WEBPACK FOOTER //
// src/company/wait-reception.vue